import React, { useState } from "react";
import { Container, Nav, NavItem, NavLink } from "reactstrap";
import { useTranslation } from "react-i18next";
import OrdersLive from "./OrdersLive";
import OrderMenu from "./OrderMenu";
import OrderSettings from "./OrderSettings";
import Promotions from "./Promotions";
import Campaigns from "./Campaigns";
import OrderStats from "./OrderStats";

const TABS = ["live", "menu", "promo", "campaigns", "stats", "settings"];

const Orders = () => {
  const { t } = useTranslation("orders");
  const [tab, setTab] = useState("live");
  return (
    <div className="content">
      <Container fluid>
        <Nav tabs className="mb-3">
          {TABS.map((k) => (
            <NavItem key={k}>
              <NavLink active={tab === k} onClick={() => setTab(k)} style={{ cursor: "pointer" }}>{t(`tabs.${k}`)}</NavLink>
            </NavItem>
          ))}
        </Nav>
        {tab === "live" && <OrdersLive />}
        {tab === "menu" && <OrderMenu />}
        {tab === "promo" && <Promotions />}
        {tab === "campaigns" && <Campaigns />}
        {tab === "stats" && <OrderStats />}
        {tab === "settings" && <OrderSettings />}
      </Container>
    </div>
  );
};

export default Orders;
